import {Component, OnInit, Inject, ElementRef} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  SELECT_ITEM_HEIGHT_EM,
} from "@angular/material";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  CommonService,
  AlertService,
  AdminService,
  ProjectService,
  LeadService,
} from "../../_services/";
import {ToastrService} from "ngx-toastr";
import {environment} from "../../../environments/environment";
import {Router, ActivatedRoute} from "@angular/router";
import {emailListProject} from "../../_helper/global";

// Algolia
import algoliasearch from "algoliasearch";
import {Subscription} from "rxjs";

const client = algoliasearch(
  environment.algolia.appId,
  environment.algolia.adminAPIKey
);
const index = client.initIndex("projects");
const index2 = client.initIndex("contacts");

@Component({
  selector: "app-add-project-dialog",
  templateUrl: "./add-project-dialog.component.html",
  styleUrls: ["./add-project-dialog.component.scss"],
  host: {
    "(document:click)": "onClick($event)",
  },
})
export class AddProjectDialogComponent implements OnInit {
  existingProjectForm: FormGroup;
  scratchProjectForm: FormGroup;
  submitted = false;
  showForm: String = "scratch"; //
  errMsg: String;
  clients: any[] = [];
  locations: any[] = [];
  projectStatus: any[] = [];
  designers: any[] = [];
  addressGoogleObject = {};
  defaultLocation: "";
  showroomList: any;
  searchContacts: any[];
  selectedContactId: string;
  isContactReadOnly = false;
  existingProjectList: any[] = [];
  pIndex: any;
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;
  projectId: string;
  contactId: string;
  constructor(
    public dialogRef: MatDialogRef<AddProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private _common: CommonService,
    private _alert: AlertService,
    private _admin: AdminService,
    private _project: ProjectService,
    private _lead: LeadService,
    private _toastr: ToastrService,
    private _router: Router,
    private _route: ActivatedRoute
  ) {}

  ngOnInit() {
    const currentURL = window.location.href;
    const urlArr = currentURL.split("/").reverse();
    if (urlArr[1] == "project") {
      this.projectId = urlArr[0];
      this.getProjectDetail(this.projectId);
    } else {
      this.contactId = urlArr[0];
      this.getContactDetail(this.contactId);
    }

    if (
      this.data &&
      this.data.modalSource &&
      (this.data.modalSource == "contact" || this.data.modalSource == "project")
    ) {
      this.showForm = "";
    }
    this.existingProjectForm = this.formBuilder.group({
      created_from_project_id: [null, [Validators.required]],
      name: ["", [Validators.required]],
      // address : [null, []]
    });
    this.scratchProjectForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      accounting_ref: ["", []],
      contact_id: [null, []],
      owner_contact: ["", [Validators.required]],
      address: [null, []],
      showroom_id: [null, []],
      budget: ["", []],
      rs2_import: ["", []],
    });
    // this.getProjectStatus();

    if (emailListProject.includes(localStorage.getItem("rs-email"))) {
      this.getDesignerList("all");
      // this.getClientList('all');
    } else {
      this.getDesignerList(localStorage.getItem("uid"));
      // this.getClientList('filter');
    }
    this.getShowroomList();

    if (
      this.data != null &&
      this.data.source &&
      this.data.source === "contact"
    ) {
      this.isContactReadOnly = true;
    }
    if (this.data != null && this.data.client_id && this.data.first_name) {
      this.selectedContactId = this.data.client_id;
      this.scratchProjectForm.patchValue({
        contact_id: this.data.first_name + " " + this.data.last_name,
      });
    }
    if (this.data != null && this.data.showroom_id) {
      this.scratchProjectForm.patchValue({
        showroom_id: this.data.showroom_id,
      });
    }
    if (this.data != null && this.data.address) {
      this.scratchProjectForm.patchValue({
        address: this.data.address,
      });
    }
    if (this.data != null && this.data.owner_contact_id) {
      this.scratchProjectForm.patchValue({
        owner_contact: `${this.data.owner_contact_id}`,
      });
    }
  }

  // Search Algolia...
  searchAlgolia(form) {
    this.searchContacts = [];
    const requestOptions = {
      headers: {},
    };

    // Search Contacts...
    index2.search(form.value.contact_id, requestOptions).then(({hits}) => {
      if (form.value.keyword != "") {
        this.searchContacts = hits.map((item: any) => {
          return {
            first_name: item["first_name"],
            last_name: item["last_name"],
            id: item.objectID,
            showroom_id:
              item.showroom && item.showroom.length > 0
                ? item.showroom[0].showroom_id
                : "",
          };
        });
      }
    });
  }

  setContact(item) {
    this.selectedContactId = item.id;
    this.scratchProjectForm.patchValue({
      contact_id: `${item.first_name} ${item.last_name}`,
      showroom_id: `${item.showroom_id}`,
    });
    this.searchContacts = [];
  }

  onClick(event) {
    const divSec = (<Element>event.target).className;
    if (!divSec.includes("location-area")) this.locations = [];
  }

  getSuggestions(event) {
    this.subscription3 = this._admin
      .getSuggestions(event.target.value)
      .subscribe(
        (res) => {
          if (res) {
            this.locations = res["data"];
          }
        },
        (err) => {
          this._common.showLoader(false);
          this.errMsg = err.message;
        }
      );
  }

  selectForm(formType) {
    if (formType === "existing" && this.existingProjectList.length === 0) {
      this._common.showLoader(true);
      this._project.getContactProjectList(this.data.client_id).subscribe(
        (res) => {
          this._common.showLoader(false);
          this.existingProjectList = res;
        },
        (err) => {
          this._common.showLoader(false);
          this.errMsg =
            err.error && err.error.message
              ? err.error.message
              : "Something went wrong";
        }
      );
    }
    this.showForm = formType;
  }

  setLocation(locationName) {
    this.subscription3.unsubscribe();
    this.existingProjectForm.patchValue({address: locationName});
    this.locations = [];
  }

  getShowroomList() {
    this.subscription = this._admin.geShowroomList().subscribe(
      (res) => {
        this.showroomList = res;
      },
      (error) => {
        this.errMsg = error.error.message
          ? error.error.message
          : "Something went wrong!";
      }
    );
  }

  setLocation2(location) {
    this.scratchProjectForm.patchValue({address: location.description});
    this.addressGoogleObject = location;
    this.locations = [];
  }
  removeLocation() {
    // this.locations =[];
  }

  changeLocation(type) {
    const showroomControl = this.scratchProjectForm.get("showroom_id");
    const addressControl = this.scratchProjectForm.get("address");
    if (type === "showroom") {
      showroomControl.setValidators([Validators.required]);
      addressControl.setValidators(null);
    } else {
      addressControl.setValidators([Validators.required]);
      showroomControl.setValidators(null);
    }

    this.defaultLocation = type;
  }
  /*
  getClientList(listType){
    this._common.showLoader(true);
    if(listType==="all"){
      this._lead.getAllContacts().subscribe(res=>{
        this.clients = res;
        
      },error=>{
        this.errMsg = error.error.message ? error.error.message :'Something went wrong!';
      })  
    }
    else {
      this._lead.getFilteredContacts(localStorage.getItem('uid')).subscribe(res=>{
        this.clients = res;
        
      },error=>{
        this.errMsg = error.error.message ? error.error.message :'Something went wrong!';
      })  
    }
  }
*/
  // get project status
  // getProjectStatus(){
  //   this._common.showLoader(true);
  //   this._project
  //   .getProjectStatusList().subscribe(res =>{
  //     this._common.showLoader(false);
  //     this.projectStatus = res;
  //   },err=>{
  //     this.errMsg = err.error.message ?  err.error.message : 'Something went wrong';
  //   });
  // }

  // Get designer list
  getDesignerList(listType) {
    // this._common.showLoader(true);
    this.subscription2 = this._lead.getDesignerList(listType).subscribe(
      (res) => {
        // this._common.showLoader(false);
        this.designers = res.map((item) => item.payload.doc.data());
      },
      (err) => {
        this.errMsg =
          err.error && err.error.message
            ? err.error.message
            : "Something went wrong";
      }
    );
  }

  // get project details
  getProjectDetail(projectId) {
    this._project.getProjectDataById(projectId).subscribe(
      (res: any) => {
        if (res && res.payload && res.payload.exists == true) {
          this.selectedContactId = res.payload.data().contact_id;
          this.scratchProjectForm.patchValue({
            contact_id:
              res.payload.data().contact_first_name +
              " " +
              res.payload.data().contact_last_name,
          });
        }
      },
      (error) => {
        this._common.showLoader(false);
        this.errMsg = error.error.message
          ? error.error.message
          : "Something went wrong";
      }
    );
  }

  // get contact details
  getContactDetail(contactId) {
    this._lead.getContactById(contactId).subscribe(
      (res: any) => {
        if (res && res.payload && res.payload.exists == true) {
          this.selectedContactId = res.payload.data().id;
          this.scratchProjectForm.patchValue({
            contact_id:
              res.payload.data().first_name +
              " " +
              res.payload.data().last_name,
          });
        }
      },
      (error) => {
        this._common.showLoader(false);
        this.errMsg = error.error.message
          ? error.error.message
          : "Something went wrong";
      }
    );
  }

  hideAddProjectDialog() {
    this.dialogRef.close();
  }

  get fval() {
    return this.existingProjectForm.controls;
  }

  get fval2() {
    return this.scratchProjectForm.controls;
  }
  // Copy From Existing
  onFormSubmit(): void {
    this.submitted = true;
    if (this.existingProjectForm.invalid) {
      return;
    }
    let form = this.existingProjectForm.value;
    this.pIndex = this.existingProjectList.findIndex(
      (item) => item.payload.doc.id === form.created_from_project_id
    );

    form.uid = localStorage.getItem("uid");
    form.accounting_ref = this.existingProjectList[
      this.pIndex
    ].payload.doc.data().accounting_ref
      ? this.existingProjectList[this.pIndex].payload.doc.data().accounting_ref
      : "";
    form.contact_id =
      this.existingProjectList[this.pIndex].payload.doc.data().contact_id;
    form.address =
      this.existingProjectList[this.pIndex].payload.doc.data().address;
    form.address_google = this.existingProjectList[
      this.pIndex
    ].payload.doc.data().address_google
      ? JSON.stringify(
          this.existingProjectList[this.pIndex].payload.doc.data()
            .address_google
        )
      : "";
    form.archived = this.existingProjectList[this.pIndex].payload.doc.data()
      .archived
      ? this.existingProjectList[this.pIndex].payload.doc.data().archived
      : "";
    form.budget = this.existingProjectList[this.pIndex].payload.doc.data()
      .budget
      ? this.existingProjectList[this.pIndex].payload.doc.data().budget
      : "";
    form.status_id = 29;
    form.owner_contact_id =
      this.existingProjectList[this.pIndex].payload.doc.data().owner_contact_id;
    form.showroom_id =
      this.existingProjectList[this.pIndex].payload.doc.data().showroom_id;

    this._common.showLoader(true);
    this._project.createProject(form).subscribe(
      (res: any) => {
        if (res) {
          this._common.showLoader(false);
          this._toastr.success(`${res.message}`, "", {timeOut: 4000});
          this.dialogRef.close();
        }
      },
      (err) => {
        this._common.showLoader(false);
        this.errMsg = err.error.message
          ? err.error.message
          : "Something went wrong";
      }
    );
  }

  onFormSubmit2(): void {
    if (!this.selectedContactId) {
      alert("You selected an invalid contact");
      return;
    }

    this.submitted = true;
    if (this.scratchProjectForm.invalid) {
      return;
    }
    this._common.showLoader(true);
    let form = this.scratchProjectForm.value;

    form.status_id = 29;
    form.uid = localStorage.getItem("uid");
    form.contact_id = this.selectedContactId ? this.selectedContactId : "";

    if (form.rs2_import === true) {
      this._project.importRs2Project(form).subscribe(
        (res) => {
          if (res) {
            this._common.showLoader(false);
            this._toastr.success(`Project imported successfully!`, "", {
              timeOut: 4000,
            });
            this.dialogRef.close();
          }
        },
        (err) => {
          this._common.showLoader(false);
          this.errMsg = err.error.message
            ? err.error.message
            : "Something went wrong";
        }
      );
    } else {
      (form.owner_contact_id = form.owner_contact),
        (form.owner_user_id = form.owner_contact);
      // const tempAdminContactId = this.designers.filter(item=> item.user_id===form.owner_user_id);
      // form.owner_contact_id = form.owner_user_id && tempAdminContactId.length>0 ? tempAdminContactId[0].id : '';

      form.address_google = JSON.stringify(this.addressGoogleObject);
      // Code to insert data over Firebase
      this._project.createProject(form).subscribe(
        (res) => {
          // Code to save data over Algolia
          //  form.objectID = res['project_id'];
          //  index.saveObjects([form], {
          //    autoGenerateObjectIDIfNotExist: true
          //  }).then(({ objectIDs }) => {})
          if (res) {
            this._common.showLoader(false);
            this._toastr.success(`Project added successfully!`, "", {
              timeOut: 4000,
            });
            this._router.navigate(["/project", res["project_id"]]);
            this.dialogRef.close();
          }
        },
        (err) => {
          this._common.showLoader(false);
          this.errMsg = err.error.message
            ? err.error.message
            : "Something went wrong";
        }
      );
    }
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscription2) this.subscription2.unsubscribe();
    if (this.subscription3) this.subscription3.unsubscribe();
  }
}
